export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20abstract%20composition%20of%20flowing%20gradient%20curves%20in%20warm%20sand%20terracotta%20and%20olive%20tones%20with%20soft%20overlapping%20translucent%20layers%2C%20modern%20elegant%20texture%2C%20smooth%20organic%20shapes%20creating%20depth%2C%20contemporary%20art%20style%2C%20warm%20sophisticated%20atmosphere%2C%20horizontal%20sweeping%20composition%2C%20no%20text%20or%20hard%20edges&width=1600&height=900&seq=cta-bg-v2-004&orientation=landscape"
          alt="ACBuySpreadsheet - Start using the order tracking system today"
          title="Get Started with ACBuySpreadsheet - Smarter Order Management"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-black/45"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 lg:gap-16">
          <div className="lg:max-w-lg">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-none tracking-tight">
              acbuy <span className="block font-light italic">spreadsheet</span>
            </h2>
            <p className="mt-6 text-sm md:text-base text-white/70 leading-relaxed max-w-md">
              Start using the ACBuySpreadsheet system today and improve your order efficiency immediately. Access the structured tracking framework trusted by buyers worldwide.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 lg:pb-6">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-between gap-3 px-6 py-4 bg-white text-foreground-950 rounded-full text-sm md:text-base font-semibold hover:bg-white/95 transition-colors whitespace-nowrap min-w-[200px]"
            >
              buy it now
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-950 text-white">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-4 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              ACBuy Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>

        <p className="mt-10 md:mt-14 text-sm md:text-base text-white/60 max-w-md lg:ml-auto lg:text-right">
          A data-driven system for structured order tracking, cost comparison, and smarter purchasing.
        </p>
      </div>
    </section>
  );
}